import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
    colWidth?: string;
    move?:boolean;
    left?:string;
    margin?:string;
    selected?: boolean;
    backgroundColor?: string;
    transparent?: boolean;
}

export const Root = styled.div`
  max-width: 1147px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: ${(props: IRootProps) => props.transparent ? `solid 2px ${C.WHITE}` : props.selected ? `solid 1px ${C.BLUE}` : 'solid 1px rgba(130, 130, 130, 0.5)'};
  background-color: ${(props: IRootProps) => props.backgroundColor};
  position:relative;
  margin-right:16px;
  &:hover {
    color: ${(props: IRootProps) => props.transparent ? C.WHITE : C.DARK_GRAY}; 
    background-color: ${(props: IRootProps) => props.transparent ? "rgba(255, 255, 255, 0.1)" : "#f5f5f5"};
    border-radius: 5px;
  }
`;


export const MenuFilter = styled.div`
  max-width: 1147px;
  height: 340px;
  margin-top: 8px;
  display: none;
  position: absolute;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 80;
  padding: 16px 0px;
  left: 0;
  margin-left: ${(props: IRootProps) => props.margin };
  margin-right: ${(props: IRootProps) => props.margin };
  transition: margin-left 2s ease;
`

export const FilterContainer = styled.div`
  display:inline-block;
`;

export const ButtonFilter = styled.button`
  height: 35px;
  font-size: 16px;
  text-align: left;
  color:  ${(props: IRootProps) => props.transparent ? C.WHITE : props.selected ? C.BLUE : C.LIGHT_GRAY};
  padding: 0px 16px;
  border: unset;
  display:inline-block;
  background-color: transparent;
  cursor: pointer;
  margin: 0px 10px;
  &:hover ~ ${MenuFilter} {
    display: block;
  }
  &:focus {
      outline: none;
  }
`

export const Container = styled.div`
`

export const List = styled.div`
  height: 338px;
  display: inline-block;
  overflow-x: hidden;
  overflow-y: auto;
  width:264px;
  position:relative;
  &:after{
      content: " ";
      position: absolute;
      border-left: 1px rgba(32, 64, 120, 0.2) solid;
      top: 0%;
      left: 0;
      height: 100%;
      margin-top: auto;
      margin-bottom: auto;
  }
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${C.DARK_BLUE};
  padding: 0px 24px;
  margin-bottom:18px;
`

export const ParentLabel = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: rgba(18, 36, 66, 0.5);
  padding: 0px 24px;
  margin-bottom:18px;
`
  
export const EmptyContainer = styled.div`
  display: flex;
  width: 100%;
  height: 300px;
  align-items: center;
  justify-content: center;
`;

export const CText = styled.div`
display: block;
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #8d8d8d;
`;